export const PLAN_LISTAR = "PLAN_LISTAR";
export const PLAN_ZONA_LISTAR = "PLAN_ZONA_LISTAR"
export const PLAN_LISTAR_SUCCESS = "PLAN_LISTAR_SUCCESS";

export const listarPlan = (paginacion) => ({
  type: PLAN_LISTAR,
  paginacion,
});

export const listarPlanSuccess = (respuestaServidor) => ({
  type: PLAN_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarPlanError = (error) => ({
  type: PLAN_LISTAR_ERROR,
  error,
});


export const PLAN_ZONA_LISTAR_SUCCESS = "PLAN_ZONA_LISTAR_SUCCESS";
export const PLAN_LISTAR_ERROR = "PLAN_LISTAR_ERROR";
export const PLAN_ZONA_LISTAR_ERROR = "PLAN_ZONA_LISTAR_ERROR";

export const listarPlanZona = (paginacion) => ({
  type: PLAN_ZONA_LISTAR,
  paginacion,
});

export const listarPlanZonaSuccess = (respuestaServidor) => ({
  type: PLAN_ZONA_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarPlanZonaError = (error) => ({
  type: PLAN_ZONA_LISTAR_ERROR,
  error,
});

export const GUARDAR_PLAN = "GUARDAR_PLAN";
export const GUARDAR_PLAN_SUCCESS = "GUARDAR_PLAN_SUCCESS";
export const GUARDAR_PLAN_ERROR = "GUARDAR_PLAN_ERROR";

export const guardarPlan = (plan, onSuccess) => ({
  type: GUARDAR_PLAN,
  plan,
  onSuccess,
});

export const guardarPlanSuccess = (respuestaServidor) => ({
  type: GUARDAR_PLAN_SUCCESS,
  respuestaServidor,
});

export const guardarPlanError = (errorContenido) => ({
  type: GUARDAR_PLAN_ERROR,
  errorContenido,
});

export const GUARDAR_PLAN_ZONA = "GUARDAR_PLAN_ZONA";
export const GUARDAR_PLAN_ZONA_SUCCESS = "GUARDAR_PLAN_ZONA_SUCCESS";
export const GUARDAR_PLAN_ZONA_ERROR = "GUARDAR_PLAN_ZONA_ERROR";

export const guardarPlanZona = (planZona,onSuccess) => ({
  type: GUARDAR_PLAN_ZONA,
  planZona,
  onSuccess,
});

export const guardarPlanZonaSuccess = (respuestaServidor) => ({
  type: GUARDAR_PLAN_ZONA_SUCCESS,
  respuestaServidor,
});

export const guardarPlanZonaError = (errorContenido) => ({
  type: GUARDAR_PLAN_ZONA_ERROR,
  errorContenido,
});

export const LISTAR_ZONA_ACTIVA = "LISTAR_ZONA_ACTIVA"
export const LISTAR_ZONA_ACTIVA_SUCCESS = "LISTAR_ZONA_ACTIVA_SUCCESS";
export const LISTAR_ZONA_ACTIVA_ERROR = "LISTAR_ZONA_ACTIVA_ERROR";

export const listarZonaActiva = () => ({
  type: LISTAR_ZONA_ACTIVA
});

export const listarZonaActivaSuccess = (respuestaServidor) => ({
  type: LISTAR_ZONA_ACTIVA_SUCCESS,
  respuestaServidor,
});

export const listarZonaActivaError = (error) => ({
  type: LISTAR_ZONA_ACTIVA_ERROR,
  error,
});